import React, { useEffect } from 'react';
import { secureStorage } from 'utils/secureStorage';
import './styles.scss';
import Banner from 'components/Home/Banner';
import IntroStassify from 'components/Home/IntroStassify';
import PopularJobs from 'components/Home/PopularJobs';
import ForEmployees from 'components/Home/ForEmployees';
import WhatIsStassify from 'components/Home/WhatIsStassify';
import UsersExpect from 'components/Home/UsersExpect';
import HowItWorks from 'components/Home/HowItWorks';
import DownloadStassifyApp from 'components/Home/DownloadStassifyApp';
import useAuthStore from 'store/auth';
import { USER_TYPES } from 'constants/index';
import { usePageVisitMutation } from 'services';

const Home: React.FC = () => {
	const { token: isAuthenticated, user }: Record<string, any> = useAuthStore(
		(state) => state.userInfo ?? {},
	);
	const { mutateAsync: pageVisitMutation } = usePageVisitMutation();
	secureStorage.setItem('pageVisit', 'home_a');

	useEffect(() => {
		const updateIp = () => {
			const ipAddress = secureStorage.getItem('ipAddress') ?? '';
			if (!ipAddress) return;

			pageVisitMutation({ type: 'startpage_a', ipAddress });
		};
		updateIp();

		// Listen to custom event triggered in App.tsx
		window.addEventListener('ipAddressChanged', updateIp);

		return () => {
			window.removeEventListener('ipAddressChanged', updateIp);
		};
	}, [pageVisitMutation]);

	return (
		<div className="home-page">
			<Banner />
			{!isAuthenticated && <ForEmployees />}
			{isAuthenticated && (
				<>
					<IntroStassify />
					{/* <WhatIsStassify /> */}
					{/* <HowItWorks /> */}
					{/* <UsersExpect /> */}
				</>
			)}
			{/* {(user?.userType === USER_TYPES.SEEKER || !isAuthenticated) && <PopularJobs />} */}
			<DownloadStassifyApp />
		</div>
	);
};

export default Home;
